import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const LoadingIndicator = ({ size, type, loaderType, className }) => {
    return (
        <div
            className={classNames(
                'loading-indicator',
                className,
                { [`loading-indicator--${size}`]: size },
                { [`loading-indicator--type-${type}`]: type },
                { [`loading-indicator--loader-${loaderType}`]: loaderType }
            )}
        >
            <span className="loading-indicator__loader" />
        </div>
    )
}

LoadingIndicator.propTypes = {
    size: PropTypes.string,
    type: PropTypes.string,
    loaderType: PropTypes.string,
    className: PropTypes.string,
}

export default LoadingIndicator
